export default "__VITE_ASSET__DwT5ll6q__"